module.exports = __webpack_public_path__ + "static/media/Electric.b788f2d7.svg";